import * as React from "react"
import { Box } from "@mui/material"
import { formatDate } from "@ui-seeker/utils"

import { NotAllowedBlock } from "@components"


export default function streetDateColumn() {
	return [{
		name: 'streetDate', label: 'Salsify Street Date',
		options: {
			display: 'excluded',
			customBodyRowRender: value => formatDate(value, { isString: true })
		}
	}, {
		name: 'streetDate',
		label: 'Salsify Street Date',
		options: {
			filter: false,
			setCellHeaderProps: () => ({
				sx: { whiteSpace: 'pre-line', minWidth: 30 }
			}),
			setCellProps: () => ({ sx: { textAlign: 'center' } }),
			customBodyRowRender: value => <Box sx={{ textAlign: 'center' }}>
				{ value ? formatDate(value, { isString: true }) : <NotAllowedBlock /> }
			</Box>
		}
	}, {
		name: 'streetDateStatus',
		label: 'Street Date Status',
		options: {
			display: 'excluded',
			filterOptions: { names: ['Past', 'Future'] }
		}
	}]
}
